import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { SpeciesService } from 'src/app/application/service/SpeciesService';
import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';

@Component({
  selector: 'app-admin-edit-species',
  templateUrl: './admin-edit-species.component.html',
  styleUrls: ['./admin-edit-species.component.css'],

})
export class AdminEditSpeciesComponent {

  breadcrumbMenuItems: MenuItem[] = []
  breadcrumbHome: MenuItem = {}

  profile: BasicUser | undefined
  specieId: number | undefined
  specie: Species | undefined

  constructor(
    private readonly _authService: AuthGateway,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _messageService: MessageService,
    private readonly _speciesService: SpeciesService,
    private readonly translate: TranslateService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.specieId = params['specieId']
    })
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    if (this.profile) {
      this.translate.use(this.profile.lang)
    }
    this.loadBreadcrumb()
    this.loadSpeciesDetail()
  }

  loadBreadcrumb() {
    this.translate.get([
      'AdminSpeciesManagement.PageHomeTitle',
      'AdminSpeciesManagement.PageTitle',
      'AdminSpeciesManagement.CreateEditSpecie.EditSpecieTitle',
    ]).subscribe({
      next: (translations) => {
        this.breadcrumbHome = {
          label: translations['AdminSpeciesManagement.PageHomeTitle']
        }

        this.breadcrumbMenuItems = [
          {
            label: translations['AdminSpeciesManagement.PageTitle'],
            routerLink: ['/' + Routes.adminSpecies]
          },
          {
            label: translations['AdminSpeciesManagement.CreateEditSpecie.EditSpecieTitle'],
          }
        ]
      },
      error: () => {}
    })
  }

  loadSpeciesDetail() {
    if (this.specieId) {
      this._speciesService.getById(this.specieId).subscribe({
        next: (v) => {
          this.specie = v
        },
        error: () => {
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant('AdminSpeciesManagement.Messages.FailedActionTitle'),
            detail: this.translate.instant('AdminSpeciesManagement.Messages.ErrorRetrievingSpecieText')
          })
        }
      })
    }
  }
}
